import { render } from "./ProductListComponent.vue?vue&type=template&id=9f54cbd2"
import script from "./ProductListComponent.vue?vue&type=script&lang=js"
export * from "./ProductListComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/components/ProductListComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9f54cbd2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9f54cbd2', __exports__)) {
    api.reload('9f54cbd2', __exports__)
  }
  
  module.hot.accept("./ProductListComponent.vue?vue&type=template&id=9f54cbd2", () => {
    api.rerender('9f54cbd2', render)
  })

}


export default __exports__